import classNames from 'classnames';
import { AssetItem } from '@/type';
import React from 'react';

interface FolderProps {
  canDrag?: boolean;
  canRename?: boolean;
  data: AssetItem<'folder'>;
  onDoubleClick: (item: { id: string; name: string }) => void;
}

export function Folder({ canDrag = false, canRename = false, data, onDoubleClick }: FolderProps) {
  const { id, name } = data;

  return (
    <div key={id} data-id={id} className='flex items-center justify-center flex-col w-full'>
      {/* 资产背景图 */}
      <div
        draggable={canDrag}
        style={{
          backgroundImage: `url(${require('@/assets/img/folder.png')})`,
        }}
        className='relative group bg-center bg-no-repeat bg-cover rounded-xl cursor-pointer w-full h-full aspect-square border border-transparent'
        onDoubleClick={() => {
          onDoubleClick(data);
        }}
      >
        {/* 删除图标 和 经过高亮样式 */}
        <div
          className={classNames(
            'absolute items-center justify-center w-full h-full hidden group-hover:flex rounded-xl aspect-square',
            'border border-primary',
          )}
          style={{
            background: 'linear-gradient(0deg, rgba(24, 27, 36, 0.35), rgba(24, 27, 36, 0.35))',
          }}
        />
      </div>
      {/* 资产下方的名字 */}
      <div className='w-full h-4 mt-3 text-xs'>
        <div className={classNames('w-full truncate text-center', { 'cursor-pointer': canRename })}>
          {name}
        </div>
      </div>
    </div>
  );
}
